$(() => {
  const menuController = Router.getController('customer.account.menuController');
  menuController.setRedirect(true);

  $('.content').addClass('in');
});
